import { Component, OnInit } from '@angular/core';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { BlogService } from 'src/app/services/blog.service';
import { LinkTarget } from 'ngx-extended-pdf-viewer';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {

  constructor(private blogService: BlogService, private router: Router) {
    pdfDefaultOptions.externalLinkTarget = LinkTarget.BLANK;
   }

  public base64:any;
  ngOnInit(): void {
    let url = this.router.url.split('/');
    let id = url[url.length - 1];
    this.blogService.getBlogPdf(id).subscribe(
      (res:any)=>{
        this.base64 = res.file.buffer;
      }
    )
  }

  _base64ToArrayBuffer(base64) {
	  var binary_string = base64.replace(/\\n/g, '');
    binary_string =  window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array( len );
    for (var i = 0; i < len; i++)        {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}

}
